export enum EMyBooksRoute {
  CART = "/my-books/cart/",
  CAMPAIGNS = "/my-books/campaigns/",
  LIBRARY = "/my-books/library/",
  LIKED = "/my-books/liked/",
  PURCHASED = "/my-books/purchased/",
  READ_AND_LISTEN = "/my-books/read-and-listen/",
  FOLDERS = "/my-books/shelfs/",
}

export enum EMoreMenuItemsIds {
  PreOrder = 1,
  Compilations,
  PopularAuthors,
  Podcasts,
  Hits,
  OnlyOnLitres,
  ReadItFirst,
  Subscription,
  Abonement,
  LoyaltyProgram,
  Drafts,
  Selfpub,
  Reader,
  MobileApps,
  Research,
  Journal,
  Support,
  FullVersion,
  Company,
  Listen,
  Read,
  SelfPub,
  CertificatePresent,
}

export enum EPopups {
  Default,
  Notifications,
  MyBooks,
  User,
  Genres,
  MoreMenu,
}

export enum EMobileNavLinks {
  allBooks,
  audiobooks,
  promoCode,
  genres,
  subscription,
}

export enum ECookieNames {
  drafts = "cookieChernovikPoint",
  giftCards = "cookieGiftPoint",
  podcasts = "cookiePodcastPoint",
  loyaltyProgram = "cookieLoyaltyProgramPoint",
}
